import { ConfigurationServiceSourceType, EditableDataService,
     EditableDataServiceResponse, EntityField, IConfigurationService, ICustomService,
     IDataServiceResponse } from "@lcs/frontend";
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { BE_PREFIX } from "../utils/Constants";
import AppointmentCustomService from "./appointment.custom.service";
import AppointmentConfigurationService from "./appointment.configuration.service";


class CustomerUnavailabilityService implements EditableDataService {

    readonly axios: AxiosInstance;
    readonly customerId: number;
    readonly configurationService : IConfigurationService;
    readonly customService: ICustomService;

    
    constructor(axios: AxiosInstance, customerId: number) {
        this.axios = axios;
        this.customerId = customerId;
        this.configurationService = new AppointmentConfigurationService({
            entityDefinitionSource: ConfigurationServiceSourceType.axios,
            axios: this.axios,
            entityDefinitionJsonFilePath: null,
            entityRoleJsonFilePath: null
          });
        this.customService = new AppointmentCustomService(this.axios);
    }

    getData(): Promise<IDataServiceResponse> {
        let config: AxiosRequestConfig = {
            params: {
                idCliente: this.customerId
            }
        };
        return this.axios
        .get((process.env.REACT_APP_BE_URL??"") + BE_PREFIX.APPOINTMENT + "/api/data/indisponibilita/filterByCliente", config)
        .then((result: AxiosResponse<any>) => {
            let response = {
                data: result.data.data,
                totals: {}
            }
            return response;
        });
    }
    getReferenceData(path: string): Promise<object[]> {
        let config: AxiosRequestConfig = {
        };
        return this.axios
        .get((process.env.REACT_APP_BE_URL??"") + BE_PREFIX.APPOINTMENT + "/api/data/cliente/" + this.customerId, config)
        .then((result: AxiosResponse<any>) => {
            let response = [
                    result.data.data
                ];
            return response;
        });
    }

    addObj(obj: object): Promise<EditableDataServiceResponse> {
        return this.axios
          .post((process.env.REACT_APP_BE_URL??"") + BE_PREFIX.APPOINTMENT + "/api/data/indisponibilita", obj)
          .then((result : AxiosResponse<any>) => {
            return result.data;
        });
    }
    updateObj(obj: any): Promise<EditableDataServiceResponse> {
        const params = new URLSearchParams([['itemId', obj.id]]);
        return this.axios
          .put((process.env.REACT_APP_BE_URL??"") + BE_PREFIX.APPOINTMENT + "/api/data/indisponibilita", obj, { params })
          .then((result : AxiosResponse<any>) => result.data);
    }
    deleteObj(obj: any): Promise<EditableDataServiceResponse> {
        const params = new URLSearchParams([['itemId', obj.id]]);
        return this.axios
            .delete((process.env.REACT_APP_BE_URL??"") + BE_PREFIX.APPOINTMENT + "/api/data/indisponibilita", {params})
            .then((result : AxiosResponse<any>) => result.data);
    }
    getConfiguration(): Promise<EntityField[]> {
        return this.configurationService.getDefinitions("indisponibilita")
        .then( (result: EntityField[]) => {
            result.forEach((ef: EntityField) => {
                if (ef.name === "idCliente") {
                    ef.hidden = true;
                    ef.readonly = true;
                    ef.defaultValue = this.customerId.toString();
                }
            })
            return result;
        });
    }
    getDocument(documentCode: string): Promise<string> {
        throw new Error("Method not implemented.");
    }
    
}

export default CustomerUnavailabilityService;